import request from "@/utils/request";
const qs = require("qs");
import { MLMReport } from "@/utils/requestApi";

export function listData(data) {
  return request({
    url: MLMReport() + "/visit/list",
    method: "POST",
    data: qs.stringify(data)
  });
}
export function validationAdd(data) {
  return request({
    url: MLMReport() + "/visit/validation_add",
    method: "POST",
    data: qs.stringify(data)
  });
}
export function addStored(data) {
  return request({
    url: MLMReport() + "/visit/add_stored",
    method: "POST",
    data: qs.stringify(data)
  });
}
export function dataNakes(data) {
  return request({
    url: MLMReport() + "/member/list_member",
    method: "POST",
    data: qs.stringify(data)
  });
}



// WEBPACK FOOTER //
// ./src/api/formVisit.js